import React, { Component } from "react";
import "../css/agent.css";
import { Table, Form, FormGroup, FormControl, ControlLabel, OverlayTrigger, Modal, Glyphicon, Checkbox, InputGroup } from 'react-bootstrap';
import Config from '../Config';
import {tooltip, getTimeInIST, format_fancy, HtmlTooltip} from '../Utils';
import { UserService } from "../Services/UserService";
import { RoleService } from "../Services/RoleService";
import {Button, Paper, Typography} from '@material-ui/core';
// import ExpansionPanel from '@material-ui/core/ExpansionPanel';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Chip, Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';


const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    selected: {
        "&$selected": {
            backgroundColor: "#739f26",
            color: 'white'
        },
        color: 'black'
    }
  });

class Agent extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        rows: [],
        new_agent: { name: "", mobile_no: "", code: "", roles: []},
        return_agent: { id:"", name: "", bottle_count: 0},
        pin_agent: { id:"", name: "", code: "", re_code: ""},
        show: false,
        showReturn: false,
        master_roles: new Map(),
        rolesCheckBox: [],
        status_filter : '-1',
        edit_mode: false,
        showResetPin: false
      }
      this.refreshLocation = this.refreshLocation.bind(this);
      this.requestLocationUpdate = this.requestLocationUpdate.bind(this);
      this.toggleStatus = this.toggleStatus.bind(this);
      this.createModifyAgent = this.createModifyAgent.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
      this.edit = this.edit.bind(this);
      this.remove = this.remove.bind(this);
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.hasAdmin = this.hasAdmin.bind(this);

      this.returnBottles = this.returnBottles.bind(this);
      this.minus = this.minus.bind(this);
      this.plus = this.plus.bind(this);
      this.handleShowReturn = this.handleShowReturn.bind(this);
      this.handleCloseReturn = this.handleCloseReturn.bind(this);
      this.updateBottlesReturned = this.updateBottlesReturned.bind(this);
    }
 
    componentDidMount(){
        this.fetchRoles();
        this.props.setTitle(`Employees - ${this.state.data.length}`);
        this.interval = setInterval(() => this.fetchUserLocation(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_agent: { name: "", mobile_no: "", code: "", roles: []},
            edit_mode: false
        });
        this.resetCheckBoxes();
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleCloseReturn() {
        this.setState({ showReturn: false, return_agent: { id:"",name : "", bottle_count : 0} });
    }

    handleShowReturn() {
        this.setState({ showReturn: true });
    }

    handleCloseResetPin = () => {
        this.setState({ showResetPin: false, pin_agent: { id:"", name : "", code : "", re_code: ""} });
    }

    handleShowResetPin = () => {
        this.setState({ showResetPin: true });
    }

    handlePinChange = (type, e) => {
        let pin_agent = this.state.pin_agent;
        pin_agent[type] = e.target.value;
        this.setState({pin_agent});
    }

    updateResetPin = (e) => {
        e.preventDefault();
        let pin_agent = this.state.pin_agent;
        if(pin_agent.code !== pin_agent.re_code){
            this.props.showSnackBar("New PIN and Reset PIN's don't match", "error");
        } else {
            UserService.updatePin({'user-id' : this.props.user.id, 'user-name': this.props.user.name }, {id : pin_agent.id, name: pin_agent.name, code: pin_agent.code})
            .then(() => {
                this.setState({
                    pin_agent: {  id:"", name : "", code : "", re_code: ""}
                });
                this.fetchData();
                if(this.state.showResetPin) this.handleCloseResetPin();
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    updateBottlesReturned(e){
        e.preventDefault();
        UserService.updateBottlesReturned(this.state.return_agent.id, this.state.return_agent.bottle_count)
        .then(() => {
            this.setState({
                return_agent: {  id:"", name : "", bottle_count : 0}
            });
            this.fetchData();
            if(this.state.showReturn) this.handleCloseReturn();
        })
        .catch((error) => {
            console.log(error);
        });
    }

    minus(e, type) {
        e.preventDefault();
        let modal = this.state.return_agent;
        switch(type){
            case "bottle_count":
                if ( modal.bottle_count > 0 ){
                    --modal.bottle_count;
                    this.setState({return_agent: modal})
                }
                return;
            default:
                return;
        }
    }

    plus(e, type){
        e.preventDefault();
        let modal = this.state.return_agent;
        switch(type){
            case "bottle_count":
                    ++modal.bottle_count;
                    this.setState({return_agent: modal})
                return;
            default:
                return;
        }
    }

    fetchData(){
        this.props.isLoading(true);
        this.props.showProgressDialog('Calling Superheroes...');
        UserService.getAgentList(this.state.status_filter)
        .then((data) => {
            console.log("Agent");
            console.log(data);
            this.setState({data: data.users,  originalData: data.users}, () => this.props.setTitle(`Employees - ${this.state.data.length}`));
            this.updateRows(data.users);
            this.fetchUserLocation();
            this.props.isLoading(false);
            this.props.closeProgressDialog();
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.props.closeProgressDialog();
        });
    }

    handleSelection = (event, status) => {
        this.setState({
            status_filter: status
        }, () => this.filterCriteria());
    }

    resetPin = (e, user) => {
        e.preventDefault();
        let pin_agent = {};
        pin_agent.id = user.id;
        pin_agent.name = user.name;
        pin_agent.old_code = user.code;
        this.setState({pin_agent: pin_agent});
        this.handleShowResetPin();
    }

    updateRows(data){
        let rows = [];
        data.forEach((user) => {
            rows.push(<UserDetails 
                        key={user.id} 
                        user={user} 
                        refreshLocation={this.refreshLocation} 
                        requestLocationUpdate={this.requestLocationUpdate} 
                        toggleStatus={this.toggleStatus} 
                        edit={this.edit} 
                        remove={this.remove} 
                        returnBottles={this.returnBottles} 
                        roles={this.state.master_roles} 
                        resetPin={this.resetPin}/>);
        });
        this.setState({rows: rows});
    }

    toggleStatus(e,user){
        e.preventDefault();
        UserService.toggleAgentStatus(user.id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
        .then((data) => {
            console.log(data);
            const status = data.status === "0" ? "Deactivated": "Activated";
            this.props.showSnackBar(`${status} user ${data.name} Account`, 'info');
            this.fetchData();
        })
        .catch(error => console.log(error));
    }

    requestLocationUpdate(e,id){
        e.preventDefault();
        UserService.requestLocationUpdate(id)
        .then((data) => {
            console.log(data);
            this.props.showSnackBar(`Requested update. Please refresh after sometime and check the location.`, 'info');
        })
        .catch(error => console.log(error));
    }

    refreshLocation(e, id){
        e.preventDefault();
        UserService.refreshLocation(id)
        .then((data) => {
            data = data.user_locations;
            let users = this.state.originalData;
            users.forEach(user => {
                if(data[user.id]){
                    user.current_location = data[user.id].current_location;
                    user.location_update_date = data[user.id].modified_date;
                }
            });
            console.log(users);
            this.setState({data: users,  originalData: users});
            this.filterCriteria();
            // this.updateRows(this.state.data);
        })
        .catch(error => console.log(error));
    }

    fetchRoles(){
        this.props.isLoading(true);
        RoleService.getRoleList()
        .then((data) => {
            data = data.roles;
            let roleDetailMap = new Map();
            data.forEach(role => {
                roleDetailMap.set(role.id, role);
            });
            this.setState({master_roles: roleDetailMap}, () => this.fetchData());
            let rows = [];
            data.forEach((role) => {
                rows.push(
                    <div key={role.id}>
                        <HtmlTooltip title={<Typography variant="subtitle2">{role.description}</Typography>}>
                            <Checkbox key={role.id} defaultChecked={false} inline onChange={this.handleChangeCheckBox} name={role.id}>{role.name}</Checkbox>
                        </HtmlTooltip>
                    </div>
                );
            });
            this.setState({rolesCheckBox: rows});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchUserLocation(){
        UserService.refreshLocation()
        .then((data) => {
            data = data.user_locations;
            let users = this.state.originalData;
            users.forEach(user => {
                if(data[user.id]){
                    user.current_location = data[user.id].current_location;
                    user.location_update_date = data[user.id].modified_date;
                }
            });
            this.setState({data: users,  originalData: users});
            this.filterCriteria();
            //this.updateRows(this.state.data);
        })
        .catch(error => console.log(error));
        
    }

    filterCriteria = (e) => {
        this.props.isLoading(true);
        if(e)
            e.preventDefault();
        const searchText = this.refs.inputText.value;
        let filteredList = []
        if(this.state.status_filter === '-1'){
            filteredList = this.state.originalData.filter(data => data.name.toLowerCase().includes(searchText.toLowerCase()) || data.building_name.toLowerCase().includes(searchText.toLowerCase()));
        } else {
            filteredList = this.state.originalData.filter(data => data.status === this.state.status_filter && (data.name.toLowerCase().includes(searchText.toLowerCase()) || data.building_name.toLowerCase().includes(searchText.toLowerCase())));
        }
        if(this.refs.inputText.value.length === 0){
            filteredList = this.state.status_filter === '-1' ? this.state.originalData : this.state.originalData.filter(data => data.status === this.state.status_filter);
        }
        console.log(this.state.status_filter, filteredList.length);
        this.setState({
            data: filteredList,
            message: filteredList.length > 0 ? '' : 'No matching Agent'
        });
        this.updateRows(filteredList);
        this.props.isLoading(false);
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_agent;
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    handleChangeCheckBox(e) {
        let change = this.state.new_agent;
        if(e.target.checked && !change['roles'].includes(e.target.name)){
            change['roles'].push(e.target.name);
        } else {
            var index = change['roles'].indexOf(e.target.name);
            change['roles'].splice(index, 1);
        }
        this.setState({new_agent: change});
    }

    hasAdmin() {
        let hasAdminRole = false;
        this.state.new_agent.roles.forEach((roleId) => {
            if(this.state.master_roles.get(roleId).name === "Admin"){
                hasAdminRole = true;
            }
        });
        return hasAdminRole;
    }

    createModifyAgent(e){
        e.preventDefault();
        if(this.state.new_agent.name && this.state.new_agent.mobile_no && this.state.new_agent.code.length >= 4 && this.state.new_agent.roles.length > 0){
            if(this.hasAdmin() || (!this.hasAdmin() && (!this.state.new_agent.id || (this.state.new_agent.id && this.state.new_agent.id !== this.props.user.id)))){
                this.props.showConfirmDialog("Confirm?", undefined, () => {
                    this.createAgentAPI(this.state.new_agent);
                    this.props.closeConfirmDialog();
                });
            } else {
                this.props.showConfirmDialog("Cannot remove Admin role for currently logged in user", undefined, undefined);
            }
        } else if(this.state.new_agent.name && this.state.new_agent.mobile_no && this.state.new_agent.roles.length === 0){
            this.props.showSnackBar(`Please select atleast one role`, 'error');
        } else if(this.state.new_agent.code.length < 4){
            this.props.showSnackBar(`Code should be atleast 4 characters`, 'error');
        } else {
            this.props.showSnackBar(`Please fill all the details and continue`, 'error');
        }
    }

    remove(e, user){
        e.preventDefault();
        if(this.props.user.id !== user.id){
            this.props.showConfirmDialog("Confirm removal of Agent?", undefined, () => {
                this.removeAgentAPI(this.dialog, user.id);
                this.props.closeConfirmDialog();
            });
        } else {
            this.props.showConfirmDialog("Cannot remove yourself", undefined, undefined);
        }
    }

    removeAgentAPI(dialog, id){
        UserService.removeAgent(id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
        .then((data) => {
            console.log(data);
            this.fetchData();
        })
        .catch((error) => {
            this.props.showConfirmDialog("Could not remove agent. Please make sure there are no routes associated with the agent and try again.", undefined, undefined);
        });
    }

    returnBottles(e, user){
        e.preventDefault();
        let return_agent = {};
        return_agent.id = user.id;
        return_agent.name = user.name;
        return_agent.bottle_count = user.bottle_count;
        this.setState({return_agent: return_agent});
        this.handleShowReturn();
    }

    edit(e, user){
        e.preventDefault();
        if(user){
            let v= this.handleChangeCheckBox;
            this.setState({new_agent: user, edit_mode: true}, function () {
                let rows = [];
                this.state.master_roles.forEach((value, key, map) => {
                    rows.push(
                        <div key={key}>
                            <HtmlTooltip  key={key} title={<Typography variant="subtitle2">{value.description}</Typography>}>
                                    <Checkbox defaultChecked={user.roles.includes(value.id)} inline onChange={v} name={value.id}>{value.name}</Checkbox>
                            </HtmlTooltip>
                        </div>
                    );
                });
                this.setState({rolesCheckBox: rows});
                this.handleShow();
            });
        } else {
            this.handleShow();
        }
    }

    resetCheckBoxes(){
        let rows = [];
        this.state.master_roles.forEach((value, key, map) => {
            rows.push(
                <HtmlTooltip  key={key} title={<Typography variant="subtitle2">{value.description}</Typography>}>
                    <Checkbox key={key} defaultChecked={false} inline onChange={this.handleChangeCheckBox} name={value.id}>{value.name}</Checkbox>
                </HtmlTooltip>
            );
        });
        this.setState({rolesCheckBox: rows});
    }

    createAgentAPI(new_agent){
        //new_agent.code = 1234;
        let body = new_agent;
        this.props.isLoading(true);
        UserService.createAgent(new_agent.id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name }, body)
        .then((data) => {
            console.log(data);
            this.setState({
                new_agent: { name: "", mobile_no: "", code: "", roles: []}
            });
            this.fetchData();
            if(this.state.show) this.handleClose();
            this.props.isLoading(false);
        })
        .catch((error) => {
            this.props.isLoading(false);
            this.props.showConfirmDialog('Agent already exists with the same mobile no. Please check again.', undefined, undefined);
        });
        
    }

    getValidationStateName() {
        if(this.state.new_agent.name){
            const length = this.state.new_agent.name.length;
            if (length > 5) return 'success';
            else if (length > 3) return 'warning';
            else if (length > 0) return 'error';
        }
        return null;
    }

    getValidationStateMobileNo() {
        if(this.state.new_agent.mobile_no){
            const length = this.state.new_agent.mobile_no.length;
            if (length === 10) return 'success';
            else return 'error';
        }
        return null;
    }

    getValidationStateCode() {
        if(this.state.new_agent.code){
            const length = this.state.new_agent.code.length;
            if (length >= 4) return 'success';
            else return 'error';
        }
        return null;
    }
    
    render() {
        let {message, status_filter} = this.state;
        return (
            <div className="Home">
                <h3 style={{marginBottom: 8, marginTop: 32}}>
                    <ToggleButtonGroup
                        size="small"
                        value={status_filter}
                        exclusive
                        onChange={this.handleSelection}
                        aria-label="text alignment" style={{paddingLeft: 10}}>
                        <ToggleButton value='-1' aria-label="stores all" classes={{selected: this.props.classes.selected}}>
                            All
                        </ToggleButton>
                        <ToggleButton value='1' aria-label="stores active" classes={{selected: this.props.classes.selected}}>
                            Active
                        </ToggleButton>
                        <ToggleButton value='0' aria-label="stores deactivated" classes={{selected: this.props.classes.selected}}>
                            Deactivated
                        </ToggleButton>
                    </ToggleButtonGroup>
                </h3>
                {/* <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography className={this.props.classes.heading}>Create New Agent</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography>
                            {this.userForm("New Agent", this.createModifyAgent, "Create Agent", {inline: true} )}
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel> */}
                <div className="">
                    <Paper style={{width: "100%", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px"}}>
                        <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                            <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "100%", marginBottom: "10px", padding: "5px", borderColor:"red"}} autoComplete="off"></input>
                        </form>
                        <p style={{color:"red", margin:20}}>{message}</p>
                            { !message &&
                                <Table striped condensed hover responsive style={{maxWidth: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Mobile No</th>
                                            <th>Roles</th>
                                            <th>Route Info</th>
                                            <th>Last location</th>
                                            <th>App Version</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{textAlign: "left"}}>
                                        {this.state.rows}
                                    </tbody>
                                </Table>
                            }
                    </Paper>
                </div>
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{this.state.show ? "Edit Agent" : ""}</DialogTitle>
                        <DialogContent>
                                {this.userForm( "Edit Agent", this.createModifyAgent, "Modify")}
                        </DialogContent>
                </Dialog>
                <Modal show={this.state.showReturn} onHide={this.handleCloseReturn}>
                    <Modal.Header closeButton>
                        <Modal.Title>Pending Bottles</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="" onSubmit={this.updateBottlesReturned}>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Agent</InputGroup.Addon>
                                    <FormControl
                                        type="text"
                                        value={this.state.return_agent.name}
                                        disabled
                                        placeholder="Agent"
                                        name="name"/>
                                </InputGroup>
                            </FormGroup>
                            {'      '}
                                <FormGroup>
                                    <span style={{marginRight: "10px"}}>Bottles Pending: </span>
                                    <Glyphicon style={{marginRight: "10px"}} glyph="minus" onClick={(e) => this.minus(e, "bottle_count")}/>
                                    <Button style={{marginRight: "10px", width: "50px"}} disabled>{this.state.return_agent.bottle_count}</Button>
                                    <Glyphicon style={{marginRight: "10px"}} glyph="plus" onClick={(e) => this.plus(e, "bottle_count")}/>
                                </FormGroup>
                                <Button type="submit" onClick={this.updateBottlesReturned} style={{marginRight: "10px"}}>Save</Button>
                                {this.state.show ? (<Button onClick={this.handleCloseReturn}>Close</Button>): ""}
                        </Form>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showResetPin} onHide={this.handleCloseResetPin}>
                    <Modal.Header closeButton>
                        <Modal.Title>Reset PIN</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="" onSubmit={this.updateResetPin}>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Agent</InputGroup.Addon>
                                    <FormControl
                                        type="text"
                                        value={this.state.pin_agent.name}
                                        disabled
                                        placeholder="Agent"
                                        name="name"/>
                                </InputGroup>
                            </FormGroup>
                            {'      '}
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Enter PIN</InputGroup.Addon>
                                    <FormControl
                                        onChange={(e) => this.handlePinChange("code", e)}
                                        placeholder="New PIN"
                                        type="password"
                                        maxLength={4}
                                        length={4}
                                        name="name"/>
                                </InputGroup>
                            </FormGroup>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Re-enter PIN</InputGroup.Addon>
                                    <FormControl
                                        onChange={(e) => this.handlePinChange("re_code", e)}
                                        placeholder="Re-Enter PIN"
                                        type="password"
                                        maxLength={4}
                                        length={4}
                                        name="name"/>
                                </InputGroup>
                            </FormGroup>
                            <Button type="submit" onClick={this.updateResetPin} style={{marginRight: "10px"}}>Reset</Button>
                            {this.state.show ? (<Button onClick={this.handleCloseResetPin}>Close</Button>): ""}
                        </Form>
                    </Modal.Body>
                </Modal>
                <Fab onClick={this.edit} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                    <AddIcon />
                </Fab>
            </div>
        );
    }

    userForm = (title, submitFunction, buttonText, orientation) => (
        <Form {...orientation} className="" onSubmit={submitFunction}>
            <FormGroup
                controlId="formBasicText"
                validationState={this.getValidationStateName()}>
                {!this.state.show ? (<ControlLabel className="marginRight">{title}</ControlLabel>) : ""}
                {'      '}
                <FormControl 
                    type="text"
                    value={this.state.new_agent.name}
                    placeholder="Please enter Name"
                    name="name"
                    onChange={this.handleChange}
                />
            </FormGroup>
            {'      '}
            <FormGroup
                controlId="formBasicText"
                validationState={this.getValidationStateMobileNo()}>
                <FormControl style={{width: "135px"}}
                    type="number"
                    value={this.state.new_agent.mobile_no}
                    placeholder="Mobile no"
                    name="mobile_no"
                    pattern="[0-9]{10}"
                    onChange={this.handleChange}
                />
            </FormGroup>
            {'      '}
            {  !this.state.edit_mode && 
                <FormGroup
                    controlId="formBasicText"
                    validationState={this.getValidationStateCode()}>
                    <FormControl style={{width: "90px"}}
                        type="number"
                        value={this.state.new_agent.code}
                        placeholder="Code"
                        name="code"
                        pattern="[0-9]{4}"
                        onChange={this.handleChange}
                    />
                </FormGroup>
            }
            {'      '}
            <FormGroup>
                {this.state.rolesCheckBox}
            </FormGroup>
            {'      '}
            
                <Button type="submit" onClick={submitFunction} style={{marginRight: "10px"}}>{buttonText}</Button>
                {this.state.show ? (<Button onClick={this.handleClose}>Close</Button>): ""}
        </Form>
    )

}

class UserDetails extends Component {

    openGoogle(e, current_location){
        let location = current_location.split(",");
        e.preventDefault();
        window.open(Config.google_url+location[0]+","+location[1], "_blank");
    }

    render(){
      const user = this.props.user;
      const roles = this.props.roles;
        return (
            <tr className={user.status === "0" ? "danger" : ""}>
                <td style={{width: '15vw'}}>{user.name}</td>
                <td>
                    {user.mobile_no}
                    <Button size="small" variant="outlined" onClick={(e) => this.props.resetPin(e, user)} style={{marginTop: 5}}>Reset PIN</Button>
                </td>
                <td style={{maxWidth: '12vw'}}>
                    {
                       
                        user.roles.map((u,i) => (<Chip size="small" key={i} style={{margin: 5}} color="primary" label={roles.get(u).name}/>))
                    }
                </td>
                <td style={{textAlign : user.route ? "left" : "center"}}>
                    {
                        user.route ? 
                        user.route.split(",").map((u,i) => (<Chip size="small" variant="outlined" key={i} style={{margin: 5}} label={u}/>)) : "-"}
                </td>
                <td style={{textAlign : "center", cursor: "pointer"}} onClick={(e) => this.openGoogle(e, user.current_location)}>{user.current_location ? user.current_location + "\n(" + getTimeInIST(user.location_update_date).format(format_fancy) + ")": "-"}</td>
                <td>{user.app_version ? user.app_version : "-"}</td>
                <td>{user.status === "0" ? "Deactive" : "Active"}</td>
                <td>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Open Maps")}>
                        <Glyphicon glyph="map-marker" style={{marginRight: "10px"}} onClick={(e) => this.openGoogle(e, user.current_location)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Refresh")}>
                        <Glyphicon glyph="refresh" style={{marginRight: "10px"}} onClick={(e) => this.props.refreshLocation(e, user.id)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Request Location Update")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="repeat" onClick={(e) => this.props.requestLocationUpdate(e, user.id)} />
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Activate/Deactivate")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="off" onClick={(e) => this.props.toggleStatus(e, user)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Edit")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, user)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Remove Agent")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.remove(e, user)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Pending Bottles: " + user.bottle_count)}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="glass" onClick={(e) => this.props.returnBottles(e, user)}/>
                    </OverlayTrigger>
                </td>
            </tr>
        );
    }
}

export default withStyles(styles)(Agent);